export const STEP_STATE_ACTIVE = 'active'
export const STEP_STATE_DISABLED = 'disabled'
export const STEP_STATE_OPEN = 'open'
export const STEP_STATE_COMPLETED_WITH_ERRORS = 'errors'
export const STEP_STATE_COMPLETED = 'completed'
